import { useEffect, useState } from "react"

import { usePrevious } from "@/hooks/usePrevious"
import { CollapseDrawer } from "@/organisms/Drawers/components/CollapseDrawer"
import { ActionListCard } from "./ActionListCard"
import { ActionsCount } from "./ActionsCount"

import { Heading } from "@/molecules/Heading"
import type { ActionCollapseComponent } from "."

export const ActionCollapse: ActionCollapseComponent = (props) => {
  const { activeKey, tickets, ticketSystems, pullRequests, issueId } = props
  const ticketCount = tickets?.length ?? 0
  const prCount = pullRequests?.length ?? 0
  const totalCount = ticketCount + prCount

  const [currentActiveKey, setCurrentActiveKey] = useState(activeKey)
  const prevCount = usePrevious(totalCount)

  useEffect(() => {
    if (!totalCount || !prevCount) return

    if (totalCount > prevCount) setCurrentActiveKey(`${totalCount}`)
  }, [prevCount, totalCount])

  if (!totalCount) return null

  return (
    <CollapseDrawer
      key={currentActiveKey}
      defaultActiveKey={currentActiveKey}
      header={<Heading level={6} title="Actions" />}
      extra={
        <ActionsCount
          tickets={tickets}
          ticketSystems={ticketSystems}
          pullRequests={pullRequests}
        />
      }
    >
      <ActionListCard
        tickets={tickets}
        pullRequests={pullRequests}
        issueId={issueId}
      />
    </CollapseDrawer>
  )
}
